import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    table: 'grow',
    tr: '',
    th: `
      w-1/3
      p-2.5
      text-start
    `,
    td: 'p-2.5',
  },
  variants: {
    variant: {
      default: {
        tr: `
          text-gray-700
          [&:nth-child(odd)]:bg-gray-100
        `,
      },
      warn: {
        tr: `
          bg-yellow-100
          text-red-600
        `,
      },
    },
  },
});
